import { render, staticRenderFns } from "./TEST_YZT_XB_NL.vue?vue&type=template&id=9059cf4e&scoped=true"
import script from "./TEST_YZT_XB_NL.vue?vue&type=script&lang=js"
export * from "./TEST_YZT_XB_NL.vue?vue&type=script&lang=js"
import style0 from "./TEST_YZT_XB_NL.vue?vue&type=style&index=0&id=9059cf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9059cf4e",
  null
  
)

export default component.exports